import axios from "axios";
import * as onboardingTypes from "../../types/admin/onboardingTypes";

//task completed
export const taskCompletedAction = (body) => async (dispatch, getState) => {
  try {
    dispatch({
      type: onboardingTypes.TASK_COMPLETED_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/employee/status`,
      body,
      config
    );
    dispatch({
      type: onboardingTypes.TASK_COMPLETED_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: onboardingTypes.TASK_COMPLETED_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//GET_ALL_ONBOARDING_TASKS
export const getAllOnboardingTasksAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: onboardingTypes.GET_ALL_ONBOARDING_TASKS_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/on-boarding-temp/task/employee/all`,
      config
    );
    dispatch({
      type: onboardingTypes.GET_ALL_ONBOARDING_TASKS_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: onboardingTypes.GET_ALL_ONBOARDING_TASKS_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};
// supportCardActions.js
export const toggleSupportCard = (isVisible) => (dispatch) => {
  dispatch({
    type: onboardingTypes.TOGGLE_SUPPORT_CARD,
    payload: isVisible,
  });
};
